export default __webpack_public_path__ + "static/weekmenu-b09d203b783fa7a980d3c6e7ce88cc06.webm";